export default __webpack_public_path__ + "static/media/zx9-in-person.62c13f74.png";